export default "__VITE_ASSET__bd8042eb__"